import { SET_COUPONS_ACTIVE_FILTER } from 'Store/constants';
import { COUPONS_FILTERS } from 'Store/constants/sportTypes';

const initialState = {
  filterName: COUPONS_FILTERS.LAST_7_DAYS,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_COUPONS_ACTIVE_FILTER:
      return { filterName: action.payload };
    
    default:
      return state;
  }
};
